import { useEffect, useState, createContext } from "react";
import Section from "../models/API/responseModels/sectionsDataResponse.model";
import Action from "../models/API/responseModels/sectionActionsDataResponse.model";
import FeatureFlagContextProps from "../models/contextModels/featureFlagContext.model";
import dataConstants from "../../constants/dataConstants";
import useSections from "../utils/custom hooks/Feature Flagging/useSections";
import useSectionsActions from "../utils/custom hooks/Feature Flagging/useSectionActions";

interface FeatureFlagProviderProps {
  children: React.ReactNode;
}
export const FeatureFlagContext = createContext<
  FeatureFlagContextProps | undefined
>(undefined);

const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
}) => {
  const { data: sectionsData, isFetching } = useSections();
  const { data: actionsData, isFetching: fetchingSectionActions } = useSectionsActions();

  const sections = sectionsData?.data ?? []
  const actions = actionsData?.data ?? []
  const loading = isFetching || fetchingSectionActions;

  const isSectionActive = (sectionKey: string): boolean => {
    if (loading) return true;
    return sections.some(
      (section) => section.key === sectionKey && section.isActive
    );
  };

  const getActionsForSection = (sectionKey: string): Action[] => {
    const section = sections.find((section) => section.key === sectionKey);

    return section
      ? actions.filter(
        (action) => action.sectionId === section.id && action.isActive
      )
      : [];
  };

  return (
    <FeatureFlagContext.Provider
      value={{ sections, actions, isSectionActive, getActionsForSection, loading }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlagProvider;
